// Läser av gratisnivåns status (tid kvar och kvoter) för inloggat konto.
import { useCallback, useEffect, useState } from "react";
import { fetchFreeTierState, type FreeTierState } from "@/lib/plan/freeTier";
import { useAuth } from "@/context/auth";

export const useFreeTier = () => {
  const { user, isLoading: authLoading } = useAuth();
  const [state, setState] = useState<FreeTierState | null>(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    setState(await fetchFreeTierState());
    setLoading(false);
  }, []);

  // Anropa först när inloggningen är klar – annars nekas anropet.
  useEffect(() => {
    if (authLoading) return;
    if (!user?.id) {
      setState(null);
      setLoading(false);
      return;
    }
    void load();
  }, [authLoading, user?.id, load]);

  const isFree = Boolean(state?.is_free);

  return {
    state,
    loading,
    reload: load,
    isFree,
    /** Gratisnivån ger full åtkomst så länge provperioden löper. */
    hasFullTrialAccess: isFree && !state?.expired,
    trialExpired: isFree && Boolean(state?.expired),
  };
};
